/** Элемент с префиксами Fullscreen API для Smart TV. */
type FullscreenEl = HTMLElement & {
  webkitRequestFullscreen?: () => Promise<void> | void;
  webkitExitFullscreen?: () => Promise<void> | void;
};

type FullscreenDoc = Document & {
  webkitFullscreenElement?: Element | null;
  webkitExitFullscreen?: () => Promise<void> | void;
};

/** Проверяет, включён ли полноэкранный режим. */
export function isFullscreenActive(): boolean {
  const doc = document as FullscreenDoc;
  return Boolean(doc.fullscreenElement || doc.webkitFullscreenElement);
}

/** Входит в полноэкранный режим по жесту пользователя. */
export async function enterFullscreen(target: HTMLElement = document.documentElement): Promise<void> {
  const el = target as FullscreenEl;
  if (el.requestFullscreen) {
    await el.requestFullscreen();
    return;
  }
  if (el.webkitRequestFullscreen) {
    await el.webkitRequestFullscreen();
  }
}

/** Выходит из полноэкранного режима. */
export async function exitFullscreen(): Promise<void> {
  const doc = document as FullscreenDoc;
  if (doc.exitFullscreen) {
    await doc.exitFullscreen();
    return;
  }
  if (doc.webkitExitFullscreen) {
    await doc.webkitExitFullscreen();
  }
}

/** Есть ли в браузере Fullscreen API. */
export function canFullscreen(): boolean {
  const el = document.documentElement as FullscreenEl;
  return Boolean(el.requestFullscreen || el.webkitRequestFullscreen);
}
